export const NAMES = {
  TAG_NAME: "ab-lens-compatibility",
  TRIGGER_CHECK_CAMERA_OPEN: "ab-lens-compatibility__check-camera",
  TRIGGER_CHECK_CAMERA_CLOSE: "ab-lens-compatibility__close-check-camera",
  CLASS_INTRO: "ab-lens-compatibility__intro",
  CLASS_TABLE: "ab-lens-compatibility__table",
  CLASS_TABLE_BODY: "ab-lens-compatibility__table-body",
  CLASS_MSG: "ab-lens-compatibility__msg",
  CLASS_MSG_OPEN_PANEL: "ab-lens-compatibility__msg--open-panel",
  CLASS_MSG_CLOSE_PANEL: "ab-lens-compatibility__msg--close-panel",
  CLASS_MSG_INSTRUCTIONS: "ab-lens-compatibility__msg--instructions",
  CLASS_SEARCH_WRAPPER: "ab-lens-compatibility__search",
  MODIFIER_TABLE_ROW_COMPATIBILITY_PARTIAL: "ab-lens-compatibility__table-row--c-partial",
  MODIFIER_TABLE_ROW_COMPATIBILITY_FULL: "ab-lens-compatibility__table-row--c-full",
  CLASS_FEEDBACK: "ab-lens-compatibility__feedback",
  CLASS_FEEDBACK_WRAPPER: "ab-lens-compatibility__feedback-wrapper",
  MODIFIER_FEEDBACK_PARTIAL: "ab-lens-compatibility__feedback--partial",
  MODIFIER_FEEDBACK_FULL: "ab-lens-compatibility__feedback--full",
  MODIFIER_FEEDBACK_NONE: "ab-lens-compatibility__feedback--none",
}
